import { render, staticRenderFns } from "./u8-container-default.vue?vue&type=template&id=5e1e1efc&"
import script from "./u8-container-default.vue?vue&type=script&lang=js&"
export * from "./u8-container-default.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e1e1efc')) {
      api.createRecord('5e1e1efc', component.options)
    } else {
      api.reload('5e1e1efc', component.options)
    }
    module.hot.accept("./u8-container-default.vue?vue&type=template&id=5e1e1efc&", function () {
      api.rerender('5e1e1efc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/u8-container/components/u8-container-default.vue"
export default component.exports